export default __webpack_public_path__ + "static/media/banner_home_mobile.682f2d49.png";